<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalSchoolExaminationAndAssessmentSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/school/examination-and-assessment/cbt-exams",
                title: "Termly Exams Setup",
                description: "Configure term examinations, schedules, and exam details.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/cbt-exam-others",
                title: "Other Exams Setup",
                description: "Set up examinations outside the regular term schedule.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/mark-record",
                title: "Mark Record",
                description: "Enter, update, and review student examination marks.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/class-attendance-record",
                title: "Class Attendance Record",
                description: "Review class attendance records for assessment periods.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/conduct-assessment",
                title: "Conduct Assessment",
                description: "Assess and record student conduct for the term.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/psycomotor-skills-assessment",
                title: "Psychomotor Skills Assessment",
                description: "Assess student psychomotor skills and record results.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/physical-development-assessment",
                title: "Physical Development Assessment",
                description: "Record assessments of student physical development.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/examination-and-assessment/mock-record",
                title: "Mock Record",
                description: "Enter and review student results from mock examinations.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
